import { getGlobalStates } from "userful-chronos-app-common-js/dist/globalstates/globalStates";
import {
    REQUEST_CLUSTER_STATUS,
    REQUEST_FAILBACK,
    REQUEST_FAILOVER,
    REQUEST_FAILOVER_STATUS,
    REQUEST_GET_FAILOVER_CONFIG,
    REQUEST_UPDATE_FAILOVER_CONFIG,
} from "userful-chronos-app-common-js/dist/message/messageTypeDefinitions/failover/failover";
import { FailoverClusterConfig } from "userful-chronos-app-common-js/dist/models/failover/failover";

export const requestFailoverConfig = () => {
    getGlobalStates().eventBus && getGlobalStates().eventBus.sendMsg(REQUEST_GET_FAILOVER_CONFIG);
};

export const requestUpdateFailoverConfig = (data: FailoverClusterConfig) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_UPDATE_FAILOVER_CONFIG, data);
};

export const requestFailover = () => {
    getGlobalStates().eventBus.sendMsg(REQUEST_FAILOVER);
};

export const requestFailback = () => {
    getGlobalStates().eventBus.sendMsg(REQUEST_FAILBACK);
};

export const requestFailoverStatus = () => {
    getGlobalStates().eventBus && getGlobalStates().eventBus.sendMsg(REQUEST_FAILOVER_STATUS);
    getGlobalStates().eventBus && getGlobalStates().eventBus.sendMsg(REQUEST_CLUSTER_STATUS);
};
